import Vue from 'vue';
import Vuex from 'vuex';
//import DeviceDetector from 'device-detector-js';

//const device = (new DeviceDetector()).parse(navigator.userAgent);

Vue.use(Vuex);

export default new Vuex.Store({
    state: {

        coursesList: false,

        // General Info
        //ua_device: device.device.type ?? '',
        //ua_browser: `${device.client.name} - ${device.client.version}` ?? '',
        //ua_os: `${device.os.name} - ${device.os.version}` ?? '',
        token: '',

        // Form Info
        privacyPolicy: false,
        formSuccess: false,
        formLoading: false,

        // Handle Mclic data
        argann: '',
        altid: '',

        // Handle the Modals
        // If you have any more modals just add them here
        modal: {
            form: false,
            terms: false,
        },

        // Courses
        courseList: [],
        courseInfo: [],
    },
    getters: {
        openModals: (state) => {
            // eslint-disable-next-line no-restricted-syntax
            for (const modal in state.modal) {
                if (state.modal[modal]) return true;
            }
            return false;
        },
    },
    mutations: {
        closeAllModals: (state) => {
            Object.keys(state.modal).forEach((el) => { state.modal[el] = false; });
        },
    },
    actions: {
        closeAllModals(context) {
            context.commit('closeAllModals');
        },
    },
});
